import React from "react"

export default function WebMobile() {
  return (
    <div>
      <center>
        <iframe title="game3" src="https://itch.io/embed/1350012" height="167" width="55%" frameborder="0">
          <a href="https://karottenkopf.itch.io/dangerous-digestion-mobile">
            Dangerous Digestion Mobile by Karottenkopf
          </a>
        </iframe>
        <br />
        <iframe
          title="game4"
          id="webgl_iframe"
          frameborder="0"
          allow="autoplay; fullscreen; vr"
          allowfullscreen=""
          allowvr=""
          mozallowfullscreen="true"
          src="https://play.unity3dusercontent.com/webgl/a9d08ff2-bffa-4c1f-9bc6-ac4cdd0c3ed8?screenshot=false&embedType=embed"
          width="55%"
          height="640"
          onmousewheel=""
          webkitallowfullscreen="true"
        ></iframe>
      </center>
    </div>
  )
}
